import React, { useState, useRef } from "react";
import JHACategoryConfiguration from "../component/jha/jhaCategoryConfiguration";
import { useDispatch } from "react-redux";
import * as jhaAction from "../../../redux/actions/jhaAction";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { API_STATUS, GRID_DEFAULT_PAGE_SIZE, USER_ID } from "../../../constant/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../library/common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  ADMIN_JHA_ACTIVITIES,
  ADMIN_JHA_CATEGORY,
  ADMIN_JHA_HAZARDS,
  ADMIN_JHA_LIST_SERVICE,
  ADMIN_JHA_LIST_TEMPLATE,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { InactiveClient } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";

const JhaCategoryConfigurationContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [shwoToast, setshwoToast] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const addTriggeredRef = useRef(false);
  const updateTriggeredRef = useRef(false);

  // add Jha Category
  const addJhaCategoryData = useSelector((state) => state?.addJhaCategory);
  function addJhaCategory(data) {
    if (InactiveClient()) return;
    addTriggeredRef.current = true;
    setshwoToast(true);
    dispatch(jhaAction.addJhaCategory(data));
  }
  useEffect(() => {
    if (
      addJhaCategoryData.status == API_STATUS.SUCCESS &&
      addJhaCategoryData?.isLoading == false &&
      shwoToast &&
      addTriggeredRef.current
    ) {
      addTriggeredRef.current = false;
      toast("Category Added successfully");
      setshwoToast(false);
      getCategoriesListData(defaultData);
    }
  }, [addJhaCategoryData]);

  const defaultData = {
    page: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    search: "",
  };

  // get JHa Cat List
  const categoriesListData = useSelector((state) => state.jhaCategoryList);

  const getCategoriesListData = (data) => {
    dispatch(jhaAction.getJhaCategoryList(data));
    dispatch(jhaAction.getCategoryConfigurationFilterObj(data));
  };
  const isLoading = useSelector(
    (state) =>
      state.jhaCategoryList?.isLoading ||
      state.addJhaCategoryData?.isLoading ||
      state.updateJhaCategory?.isLoading,
  );
  const addCategoryLoading = useSelector(
    (state) =>
      state.addJhaCategoryData?.isLoading || state.updateJhaCategory?.isLoading,
  );

  useEffect(() => {
    dispatch(jhaAction.clearJha());
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("jhaCategoryListPreserveState") === "true";
    sessionStorage.removeItem("jhaCategoryListPreserveState");

    if (isFromPreserveRoute && categoriesListData?.filterObj) {
      setShouldRestoreState(true);
      getCategoriesListData(categoriesListData.filterObj);
    } else {
      setShouldRestoreState(false);
      getCategoriesListData(defaultData);
    }
  }, []);

  // edit
  const updateJhaCategoryData = useSelector(
    (state) => state?.updateJhaCategory,
  );

  function handleEditOnClick(data) {
    if (InactiveClient()) return;
    updateTriggeredRef.current = true;
    setshwoToast(true);
    dispatch(jhaAction.updateJhaCategory(data));
  }
  function handleStatusChange(data) {
    let newData = {
      categoryName: data.categoryName,
      isGlobal: false,
      categoryId: data.id,
      isActive: !data.isActive,
      listsmodifiedBy: parseInt(USER_ID()),
    };
    updateTriggeredRef.current = true;
    setshwoToast(true);
    dispatch(jhaAction.updateJhaCategory(newData));
  }
  useEffect(() => {
    if (
      updateJhaCategoryData.status === API_STATUS.SUCCESS &&
      updateJhaCategoryData?.isLoading === false &&
      shwoToast &&
      updateTriggeredRef.current
    ) {
      updateTriggeredRef.current = false;
      toast("Category Updated successfully");
      setshwoToast(false);
      const currentFilter = categoriesListData?.filterObj || defaultData;
      getCategoriesListData(currentFilter);
    }
  }, [updateJhaCategoryData]);

  const showLoader = useSelector(
    (state) =>
      state.addJhaCategoryData?.isLoading ||
      state.updateJhaCategory?.isLoading ||
      state.jhaCategoryList?.isLoading,
  );

  return (
    <div>
      {checkPrivileges([12, 58, 59, 60]) ? (
        <>
          {showLoader && <Loader />}

          <ToastContainer />
          <JHACategoryConfiguration
            addJhaCategory={addJhaCategory}
            categoriesList={categoriesListData?.data?.result?.itemList ?? []}
            itemsCount={categoriesListData?.data?.result?.itemsCount ?? []}
            isLoading={isLoading}
            getCategoriesListData={getCategoriesListData}
            addCategoryLoading={addCategoryLoading}
            handleEditOnClick={handleEditOnClick}
            handleStatusChange={handleStatusChange}
            categoriesListDatas={categoriesListData}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </div>
  );
};

export default JhaCategoryConfigurationContainer;
